module.exports = __webpack_public_path__ + "static/img/icn_discount.ad90796.svg";